import {Injectable} from '@angular/core';
import {Lead} from '../../lead.model';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError, TimeoutError} from 'rxjs';
import {environment} from '../../../environments/environment';
import {BaseHttpService} from '../base-http.service';

@Injectable({
    providedIn: 'root',
})
export class LeadsHttpService extends BaseHttpService {
    constructor(private readonly http: HttpClient) {
        super();
    }

    fetchLeads(
        latitude: number,
        longitude: number,
        radiusInKilometers: number,
    ): Observable<Lead[]> {
        return this.applyHttpOperators(
            this.http.get<Lead[]>(
                environment.backend_host +
                `/leads?latitude=${latitude}&longitude=${longitude}&radiusInKilometers=${radiusInKilometers}`,
            ),
        );
    }

    fetchLeadsWithErrorStatus(): Observable<Lead[]> {
        return this.applyHttpOperators(
            this.http.get<Lead[]>(environment.backend_host + '/leads/error-leads'),
        );
    }

    protected override handleError(error: TimeoutError | HttpErrorResponse): Observable<never> {
        if (error instanceof HttpErrorResponse && error.status === 422) {
            return throwError(() => error);
        }
        return super.handleError(error);
    }
}
